import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { useJourneyNavEnabled } from "hooks/use-journey-nav-enabled/use-journey-nav-enabled.hook";

type Props = { children: ReactNode };

// While app-init is still loading, render a spinner instead of redirecting
// so a refresh on /health-journey doesn't bounce a user who actually has
// the flag on.
export const JourneyRouteGuard = ({ children }: Props) => {
  const { enabled, isLoading } = useJourneyNavEnabled();

  if (isLoading) return <LoadingIndicator />;
  if (!enabled) return <Navigate to={APP_MANAGED_ROUTES.HOME} replace />;
  return children as JSX.Element;
};
